interface ErrorTextProps {
  error?: string;
  className?: string;
}

const ErrorText = ({ error = '', className }: ErrorTextProps) => (
  <div
    className={`error-text flex min-h-[1.25rem] items-center text-sm text-red-400${className ? ` ${className}` : ''}`}
    aria-live="polite"
  >
    {error}
  </div>
);

export default ErrorText;
